import type { FetchConfigurationSpecificationsBodyType } from "../../../../common-deprecated/types/SpecTypes";
import type { AbortableFetchFnReturnType, FetchFnReturnType } from "../../../../common-deprecated/utils/backendFetch";
import type { InitEcoConsumptionConfigurationType } from "../redux/reducers/EcoConsumptionReducer";
import {
    type EcoConsumptionSectionType,
    type EcoConsumptionDisclaimerAreaType,
    type EcoConsumptionCostType,
    EcoConsumptionAreaEnum,
} from "../types/EcoConsumptionType";

export const FETCH_ECO_CONSUMPTION_CONFIGURATION = "fetchEcoConsumptionAceConfig";
export const FETCH_ECO_CONSUMPTION_COSTS = "fetchEcoConsumptionCosts";

export type FetchEcoConsumptionAceConfigType = {
    fetchType: typeof FETCH_ECO_CONSUMPTION_CONFIGURATION;
    modelCode: string;
    result?: FetchFnReturnType<InitEcoConsumptionConfigurationType | null> | null;
};

export const fetchEcoConsumptionAceConfigUtil = (modelCode: string): FetchEcoConsumptionAceConfigType => ({
    fetchType: FETCH_ECO_CONSUMPTION_CONFIGURATION,
    modelCode,
});

export type FetchEcoConsumptionCostsType = {
    fetchType: typeof FETCH_ECO_CONSUMPTION_COSTS;
    ecoConsumptionCostService: string;
    config: FetchConfigurationSpecificationsBodyType;
    timeout?: number;
    result?: AbortableFetchFnReturnType<EcoConsumptionCostType | null>;
};

export const fetchEcoConsumptionCostsUtil = (
    ecoConsumptionCostService: string,
    config: FetchConfigurationSpecificationsBodyType,
    timeout?: number,
): FetchEcoConsumptionCostsType => ({
    fetchType: FETCH_ECO_CONSUMPTION_COSTS,
    ecoConsumptionCostService,
    config,
    timeout,
});

export const getEcoConsumptionDisclaimerIndex = (
    disclaimer: SanitizedString,
    sectionConfig: EcoConsumptionSectionType,
): number => {
    const disclaimerArea = sectionConfig.areas.find(({ type }) => type === EcoConsumptionAreaEnum.DisclaimerArea) as
        | EcoConsumptionDisclaimerAreaType
        | undefined;
    if (!disclaimerArea) return -1;
    return disclaimerArea.disclaimers.indexOf(disclaimer) + 1;
};
